import { render, staticRenderFns } from "./Dyx.vue?vue&type=template&id=473034da&scoped=true&"
import script from "./Dyx.vue?vue&type=script&lang=js&"
export * from "./Dyx.vue?vue&type=script&lang=js&"
import style0 from "./Dyx.vue?vue&type=style&index=0&id=473034da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473034da",
  null
  
)

export default component.exports